import M from "./ghl-ui.es1174.js";
import O from "./ghl-ui.es1157.js";
import { changeColor as n } from "./ghl-ui.es904.js";
const P = (p) => {
  const {
    textColor2: o,
    textColor3: x,
    textColorDisabled: t,
    primaryColor: i,
    primaryColorHover: d,
    inputColor: r,
    inputColorDisabled: g,
    borderColor: a,
    warningColor: e,
    warningColorHover: s,
    errorColor: l,
    errorColorHover: c,
    borderRadius: b,
    lineHeight: C,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: F,
    actionColor: v,
    clearColor: D,
    clearColorHover: L,
    clearColorPressed: E,
    placeholderColor: T,
    placeholderColorDisabled: W,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j
  } = p;
  return Object.assign(Object.assign({}, M), {
    countTextColorDisabled: t,
    countTextColor: x,
    heightTiny: f,
    heightSmall: H,
    heightMedium: S,
    heightLarge: F,
    fontSizeTiny: u,
    fontSizeSmall: h,
    fontSizeMedium: m,
    fontSizeLarge: $,
    lineHeight: C,
    lineHeightTextarea: C,
    borderRadius: b,
    iconSize: "16px",
    groupLabelColor: v,
    groupLabelTextColor: o,
    textColor: o,
    textColorDisabled: t,
    textDecorationColor: o,
    caretColor: i,
    placeholderColor: T,
    placeholderColorDisabled: W,
    color: r,
    colorDisabled: g,
    colorFocus: r,
    groupLabelBorder: `1px solid ${a}`,
    border: `1px solid ${a}`,
    borderHover: `1px solid ${d}`,
    borderDisabled: `1px solid ${a}`,
    borderFocus: `1px solid ${d}`,
    boxShadowFocus: `0 0 0 2px ${n(i, {
      alpha: 0.2
    })}`,
    loadingColor: i,
    // warning
    loadingColorWarning: e,
    borderWarning: `1px solid ${e}`,
    borderHoverWarning: `1px solid ${s}`,
    colorFocusWarning: r,
    borderFocusWarning: `1px solid ${s}`,
    boxShadowFocusWarning: `0 0 0 2px ${n(e, {
      alpha: 0.2
    })}`,
    caretColorWarning: e,
    // error
    loadingColorError: l,
    borderError: `1px solid ${l}`,
    borderHoverError: `1px solid ${c}`,
    colorFocusError: r,
    borderFocusError: `1px solid ${c}`,
    boxShadowFocusError: `0 0 0 2px ${n(l, {
      alpha: 0.2
    })}`,
    caretColorError: l,
    clearColor: D,
    clearColorHover: L,
    clearColorPressed: E,
    iconColor: w,
    iconColorDisabled: z,
    iconColorHover: y,
    iconColorPressed: j,
    suffixTextColor: o
  });
}, B = {
  name: "Input",
  common: O,
  self: P
}, k = B;
export {
  k as default
};
